/* MJUKA by LINTEL PDP: colour swatches + band/cup size calculator -> native variant id + ?variant= (Kaching defaults follow),
   gallery jump, Kaching per-unit size preselect, size guide modal, reviews "show more", loops, MJUKA cart drawer after any add */
(function () {
  var data = []; try { data = JSON.parse(document.querySelector('[data-jb-variants]').textContent); } catch (e) {}
  var form = document.querySelector('form[data-jb-add]');
  var colBtns = Array.prototype.slice.call(document.querySelectorAll('[data-jb-colour]'));
  var sizeSel = document.querySelector('[data-jb-sizesel]');
  var band = document.querySelector('[data-jb-band]'), cup = document.querySelector('[data-jb-cup]');
  var colName = document.querySelector('[data-jb-colname]'), sizeName = document.querySelector('[data-jb-sizename]');
  var now = document.querySelector('[data-jb-now]'), was = document.querySelector('[data-jb-was]');
  var CH = {"65": {A: "XS", B: "XS", C: "XS", D: "XS", E: "XS"}, "70": {A: "XS", B: "XS", C: "S", D: "S", E: "S"}, "75": {A: "S", B: "S", C: "M", D: "M", E: "M"},
    "80": {A: "M", B: "M", C: "M", D: "L", E: "L"}, "85": {A: "L", B: "L", C: "L", D: "XL", E: "XL"}, "90": {B: "XL", C: "XL", D: "2XL", E: "2XL"},
    "95": {B: "2XL", C: "2XL", D: "3XL", E: "3XL"}, "100": {B: "3XL", C: "3XL"}};
  var cur = { c: colName ? colName.textContent.trim() : '', s: sizeSel ? sizeSel.value : '' };
  function jump(col) { var th = document.querySelector('.oak-gal__thumbs button[data-jb-col="' + col + '"]'); if (th) th.click(); }
  function kachingSizes(s) {
    document.querySelectorAll('.kaching-bundles select').forEach(function (sel) {
      for (var i = 0; i < sel.options.length; i++) {
        if (sel.options[i].text.trim() === s && sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); break; }
      }
    });
  }
  function apply(fromUser, sizeChanged) {
    var v = data.filter(function (x) { return x.c === cur.c && x.s === cur.s; })[0];
    if (!v) return;
    if (form) { var inp = form.querySelector('input[name=id]'); if (inp) { inp.value = v.id; inp.dispatchEvent(new Event('change', { bubbles: true })); } }
    if (colName) colName.textContent = v.c;
    if (sizeName) sizeName.textContent = v.s;
    if (now) now.textContent = v.p;
    if (was && v.cp) was.textContent = v.cp;
    colBtns.forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-jb-colour') === v.c); });
    if (sizeSel) sizeSel.value = v.s;
    if (fromUser) {
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u.toString()); } catch (e) {}
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variantId: Number(v.id) } }));
      if (sizeChanged) setTimeout(function () { kachingSizes(v.s); }, 150);
    }
  }
  colBtns.forEach(function (b) { b.addEventListener('click', function () { cur.c = b.getAttribute('data-jb-colour'); apply(true, false); jump(cur.c); }); });
  if (sizeSel) sizeSel.addEventListener('change', function () { cur.s = sizeSel.value; apply(true, true); });
  function calc() {
    if (!band || !cup) return;
    var b = band.value, c = cup.value;
    if (b && CH[b]) { Array.prototype.forEach.call(cup.options, function (o) { if (o.value) o.disabled = !CH[b][o.value]; }); }
    if (b && c && CH[b] && CH[b][c]) { cur.s = CH[b][c]; apply(true, true); }
  }
  if (band) band.addEventListener('change', calc);
  if (cup) cup.addEventListener('change', calc);
  var m = location.search.match(/[?&]variant=(\d+)/);
  if (m) {
    var hit = data.filter(function (x) { return String(x.id) === m[1]; })[0];
    if (hit) { cur.c = hit.c; cur.s = hit.s; apply(false); setTimeout(function () { jump(hit.c); }, 300); }
  }

  /* bundle defaults: a different colour for every bra in a bundle (first = the chosen colour) */
  var COLS = colBtns.map(function (b) { return b.getAttribute('data-jb-colour'); });
  function spreadColours() {
    var bars = document.querySelectorAll('.kaching-bundles__bar, [class*="kaching-bundles__bar "]');
    if (!bars.length) bars = [document];
    var done = 0;
    Array.prototype.forEach.call(bars, function (bar) {
      var sels = Array.prototype.filter.call(bar.querySelectorAll('select'), function (s) {
        return Array.prototype.some.call(s.options, function (o) { return o.text.trim() === 'Leopard Pink'; });
      });
      if (sels.length < 2 || bar.getAttribute && bar.getAttribute('data-jb-spread')) return;
      var order = [cur.c].concat(COLS.filter(function (c) { return c !== cur.c; }));
      sels.forEach(function (sel, k) {
        var want = order[k % order.length];
        for (var i = 0; i < sel.options.length; i++) { if (sel.options[i].text.trim() === want && sel.selectedIndex !== i) { sel.selectedIndex = i; sel.dispatchEvent(new Event('change', { bubbles: true })); break; } }
      });
      if (bar.setAttribute) bar.setAttribute('data-jb-spread', '1');
      done++;
    });
    return done;
  }
  var tries = 0, spreadT = setInterval(function () { if (spreadColours() || ++tries > 40) clearInterval(spreadT); }, 400);

  /* size guide modal + reviews "show more" */
  var modal = document.querySelector('[data-jb-modal]');
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-jb-guide]') && modal) { modal.classList.add('is-open'); modal.setAttribute('aria-hidden', 'false'); }
    if (e.target.closest('[data-jb-mclose]') && modal) { modal.classList.remove('is-open'); modal.setAttribute('aria-hidden', 'true'); }
    if (e.target.closest('[data-jb-more]')) { var s = document.getElementById('jb-reviews'); if (s) s.classList.add('is-all'); }
  });

  /* open the MJUKA cart drawer (jb-shop.js) after any successful add: Kaching or native */
  function openDrawer() { if (window.JB) window.JB.openCart(); }
  var pending = false;
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var p = of.apply(this, arguments);
      if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
        p.then(function (r) { if (r && r.ok && !pending) { pending = true; setTimeout(function () { pending = false; openDrawer(); }, 250); } }).catch(function () {});
      }
      return p;
    };
  }
  if (form) {
    form.addEventListener('submit', function (e) {
      if (e.defaultPrevented) return;
      e.preventDefault();
      var btn = form.querySelector('[type=submit]'); btn.disabled = true;
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error('add'); btn.disabled = false; })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }
  var vids = document.querySelectorAll('[data-jb-loop]');
  if (vids.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (e) { if (e.isIntersecting) e.target.play().catch(function () {}); else e.target.pause(); }); }, { threshold: 0.3 });
    vids.forEach(function (v) { io.observe(v); });
  }
})();

/* ===== 10-02 (Edvin): Add to cart NEVER goes to /cart - every add (theme ATC, Kaching ATC, any /cart/add form) opens the JB brand cart drawer ===== */
(function () {
  if (window.__jb_atc) return; window.__jb_atc = 1;
  function open() { if (window.JB && window.JB.openCart) return window.JB.openCart(); if (window.__lntOpen) return window.__lntOpen(); }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.getAttribute || !/\/cart\/add/.test(f.getAttribute('action') || '')) return;
    if (e.defaultPrevented) return;
    e.preventDefault();
    var b = f.querySelector('[type=submit]'); if (b) b.disabled = true;
    var fd = new FormData(f), tries = 0;
    (function add() {
      fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Accept': 'application/json' }, body: fd })
        .then(function (r) {
          if (r.ok) { if (b) b.disabled = false; return open(); }
          if (r.status === 422) return r.json().then(function (j) { if (b) b.disabled = false; open(); if (j && j.description) alert(j.description); });
          throw new Error('add ' + r.status);
        })
        .catch(function () { if (++tries < 2) return setTimeout(add, 800); /* 10-06: bot check (429) or network -> normal form POST, back to this page (?opencart=1), drawer opens. Never /cart, never an alert */ try { var u = new URL(location.href); u.searchParams.set('opencart', '1'); var h = document.createElement('input'); h.type = 'hidden'; h.name = 'return_to'; h.value = u.pathname + u.search; f.appendChild(h); } catch (x) {} HTMLFormElement.prototype.submit.call(f); });
    })();
  }, false);
})();

/* 10-06: back from the fallback POST (?opencart=1) -> open the brand cart drawer and clean the URL */
(function () {
  try { var u = new URL(location.href); if (u.searchParams.get('opencart') !== '1') return; u.searchParams.delete('opencart'); history.replaceState(null, '', u.pathname + u.search + u.hash); } catch (e) { return; }
  var n = 0, t = setInterval(function () { var ok = false; for (var k in window) { if (/^[A-Z]{2,4}$/.test(k) && window[k] && typeof window[k].openCart === 'function') { window[k].openCart(); ok = true; break; } } if (!ok && window.__lntOpen) { window.__lntOpen(); ok = true; } if (ok || ++n > 40) clearInterval(t); }, 150);
})();
